<template>
  <EditorAttributionContainer :is-position-reversed="isPositionReversed">
    <p
      class="text-xs w-full text-white font-semi-bold text-decoration-none flex gap-1 items-center justify-center mb-0"
      style="z-index: 100"
    >
      <a
        :href="supportUrl"
        class="text-white text-decoration-none"
        aria-label="Report result"
        target="_blank"
        rel="noopener noreferrer"
        @click="handleReportClick"
        >{{ I18n.t("editor.magic_background.report_result") }}</a
      >
    </p>
  </EditorAttributionContainer>
</template>
<script setup lang="ts">
import { computed, inject } from "vue";
import EditorAttributionContainer from "@/components/prism/editor_attribution_container.vue";
import "@/src/i18n";
import { useEditorStore } from "@/stores/editor_store";

interface Props {
  filename?: string;
  stage?: any;
  getDataURL?: (image: any, stage: any, element?: any) => string;
  isPositionReversed?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  filename: undefined,
  stage: undefined,
  getDataURL: undefined,
  isPositionReversed: false,
});

const I18n = inject("I18n", window.I18n);
const store = useEditorStore();

const supportUrl = computed(() => {
  const subject = encodeURIComponent("Report AI generated image");
  return `${window.location.origin}/support/contact?subject=${subject}`;
});

const handleReportClick = (_event: Event) => {
  if (props.stage && props.getDataURL && store.selectedImage) {
    try {
      const konvaStage = props.stage.getStage();
      const image = store.selectedImage;

      if (konvaStage && image) {
        const dataUrl = props.getDataURL(image, konvaStage);
        const filename = props.filename?.split(".")?.[0] || `reported_image_${Date.now()}`;

        // Store image data in localStorage
        const imageData = {
          dataUrl,
          filename: `${filename}.png`,
          timestamp: Date.now(),
        };

        localStorage.setItem("reportedImage", JSON.stringify(imageData));
      }
    } catch (error) {
      console.error("Failed to store image for reporting:", error);
    }
  }
};
</script>
